/* Hurtigsoek for byuti.no.
   Ett soek for hele butikken: navn, merke, produkttype, varenummer og
   strekkode, med antall og Legg i kurv rett i treffet. Brukes paa to
   steder: soekevinduet fra headeren, og soekesiden (/search), som
   monterer seg selv paa [data-byuti-sokeside].

   Produktlista hentes fra /collections/all?view=sokeindeks og lagres i
   nettleseren i seks timer. Partnervarer kunden ikke er godkjent for,
   havner nederst i en egen gruppe uten pris og kjoepsknapp. */
(() => {
  if (window.__byutiSok) return;
  window.__byutiSok = true;

  const C = window.BYUTI_SOK || {};
  const GODKJENT = new Set((C.merker || []).map((m) => String(m).toLowerCase()));
  const TEMA = (window.Shopify && Shopify.theme && Shopify.theme.id) || 0;
  const LAGER = 'byuti-sok-indeks-v2';
  const MAKS_ALDER = 6 * 3600 * 1000;
  const MAKS_VINDU = 30;

  /* Fagord og vanlige skrivemaater. Venstre side er det kunden skriver,
     hoeyre side er ord som skal regnes som treff. */
  const SYNONYMER = {
    remover: ['limfjerner', 'fjerner', 'remover'],
    limfjerner: ['remover', 'fjerner'],
    lim: ['lim', 'bond', 'glue'],
    vippelim: ['lim', 'bond'],
    voksing: ['voks', 'filmvoks', 'wax', 'spatel'],
    vippeextensions: ['vipper', 'lashes', 'lim', 'fans'],
    hudpleie: ['serum', 'maske', 'krem', 'rens', 'toner'],
    'premade': ['premade', 'fans', 'spikes'],
    extensionslim: ['lim', 'bond'],
    brynsfarge: ['farge', 'henna', 'tint'],
    vippefarge: ['farge', 'tint'],
    glue: ['lim', 'bond'],
    pads: ['pads', 'pad', 'patch', 'oyepads', 'teip'],
    pad: ['pads', 'pad', 'patch'],
    tape: ['teip'],
    teip: ['teip', 'tape'],
    hansker: ['hansker', 'nitril'],
    lashes: ['vipper', 'lashes'],
    vipper: ['vipper', 'lashes', 'fans'],
    tweezer: ['pinsett'],
    pinsetter: ['pinsett'],
    wax: ['voks', 'wax'],
    voks: ['voks', 'wax', 'filmvoks', 'spatelvoks', 'rullevoks'],
    spatler: ['spatel', 'spatler', 'trespatler'],
    mascara: ['maskara', 'mascara'],
    maskara: ['maskara', 'mascara'],
    microbrush: ['mikrobørster', 'mikrobørste', 'microbrush'],
    mikrobrush: ['mikrobørster', 'mikrobørste'],
    vippeloft: ['lash filler', 'filler', 'vippeløft', 'lift'],
    'vippeløft': ['lash filler', 'filler', 'lift'],
    laminering: ['brow bomber', 'bomber'],
    brynslaminering: ['brow bomber', 'bomber'],
    henna: ['henna', 'xenna'],
    cleanser: ['rens', 'skumrens'],
    rens: ['rens', 'skumrens', 'cleanser'],
    benkepapir: ['benkepapir', 'papir', 'laken'],
    primer: ['primer', 'prep']
  };

  /* ── Hjelpere ─────────────────────────────────────────────────── */
  const norm = (s) => String(s || '').toLowerCase()
    .replace(/[®™©"“”«»]/g, '')
    .replace(/[^a-z0-9æøåäöéèü]+/g, ' ')
    .trim();
  const ord = (s) => norm(s).split(' ').filter(Boolean);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const kr = (oere) => new Intl.NumberFormat('nb-NO',
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(oere / 100) + ' kr';
  const mvaTekst = C.inklMva ? 'inkl. mva' : 'eks. mva';

  /* Ett tegn feil, byttet om, mangler eller ekstra. Holder for vanlige
     skrivefeil uten at soeket blir tregt. */
  function nesten(a, b) {
    if (Math.abs(a.length - b.length) > 1) return false;
    let i = 0, j = 0, feil = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++feil > 1) return false;
      if (a[i + 1] === b[j] && a[i] === b[j + 1]) { i += 2; j += 2; continue; }
      if (a.length > b.length) i++;
      else if (b.length > a.length) j++;
      else { i++; j++; }
    }
    return feil + (a.length - i) + (b.length - j) <= 1;
  }

  /* ── Indeksen ─────────────────────────────────────────────────── */
  let indeks = null, henter = null;

  function forbered(liste) {
    return liste.map((p) => {
      const varianter = p.x.map((v) => ({
        id: v[0], tittel: v[1] === 'Default Title' ? '' : v[1], sku: v[2] || '', strekkode: v[3] || '',
        pris: v[4], forpris: v[5], ledig: v[6] === 1
      }));
      const tilgang = !p.l || GODKJENT.has(String(p.v).toLowerCase());
      return {
        id: p.i, tittel: p.t, handle: p.h, merke: p.v, type: p.y, laast: !!p.l, tilgang,
        bilde: p.b, varianter,
        ledig: varianter.some((v) => v.ledig),
        typeNorm: norm(p.y),
        tittelOrd: ord(p.t),
        andreOrd: ord(p.v + ' ' + p.y + ' ' + varianter.map((v) => v.tittel).join(' ')),
        tekst: norm(p.t + ' ' + p.v + ' ' + p.y + ' ' + varianter.map((v) => v.tittel).join(' ')),
        koder: varianter.map((v) => [norm(v.sku).replace(/ /g, ''), String(v.strekkode)])
      };
    });
  }

  async function hentSide(n) {
    const svar = await fetch('/collections/all?view=sokeindeks&page=' + n, { credentials: 'same-origin' });
    if (!svar.ok) throw new Error('indeks ' + svar.status);
    return svar.json();
  }

  function hentIndeks() {
    if (indeks) return Promise.resolve(indeks);
    if (henter) return henter;
    try {
      const lagret = JSON.parse(localStorage.getItem(LAGER) || 'null');
      if (lagret && lagret.tema === TEMA && Date.now() - lagret.tid < MAKS_ALDER) {
        indeks = forbered(lagret.p);
        return Promise.resolve(indeks);
      }
    } catch (e) { /* privat vindu eller blokkert lagring: hent paa nytt */ }
    henter = (async () => {
      const forste = await hentSide(1);
      const sider = [forste];
      const rest = [];
      for (let s = 2; s <= forste.sider; s++) rest.push(hentSide(s));
      (await Promise.all(rest)).forEach((d) => sider.push(d));
      const alle = [].concat(...sider.map((d) => d.p));
      try { localStorage.setItem(LAGER, JSON.stringify({ tid: Date.now(), tema: TEMA, p: alle })); } catch (e) { /* full eller blokkert */ }
      indeks = forbered(alle);
      return indeks;
    })();
    henter.catch(() => { henter = null; });
    return henter;
  }

  /* ── Treff og rangering ───────────────────────────────────────── */
  /* Ordet slik kunden skrev det teller fullt, synonymer litt mindre */
  function alternativer(t) {
    return [{ a: t, vekt: 1 }].concat((SYNONYMER[t] || [])
      .map(norm).filter((a) => a !== t).map((a) => ({ a, vekt: 0.6 })));
  }

  function treffOrd(alt, ordliste) {
    let best = 0;
    const linje = ' ' + ordliste.join(' ') + ' ';
    for (const { a, vekt } of alt) {
      let s = 0;
      if (a.includes(' ')) { if (linje.includes(' ' + a)) s = 2; }
      else {
        for (const w of ordliste) {
          if (w === a) { s = 3; break; }
          if (w.startsWith(a)) s = Math.max(s, 2);
          else if (a.length >= 5 && (nesten(a, w) || (w.length > a.length && nesten(a, w.slice(0, a.length))))) s = Math.max(s, 1);
        }
      }
      best = Math.max(best, s * vekt);
    }
    return best;
  }

  function sok(q) {
    const tokens = ord(q);
    if (!tokens.length || !indeks) return [];
    const helKode = norm(q).replace(/ /g, '');
    const hel = norm(q);
    const ut = [];

    for (const p of indeks) {
      let poeng = 0, variant = null, ok = true;

      /* Varenummer eller strekkode som passer helt, slaar alt annet */
      if (helKode.length >= 3) {
        p.koder.forEach((k, i) => {
          if (k[0] === helKode || k[1] === helKode) { poeng += 1000; variant = p.varianter[i]; }
          else if (!variant && helKode.length >= 4 && (k[0].includes(helKode) || k[1].startsWith(helKode))) {
            poeng += 200; variant = p.varianter[i];
          }
        });
      }

      if (poeng < 200) {
        for (const t of tokens) {
          const alt = alternativer(t);
          const iTittel = treffOrd(alt, p.tittelOrd);
          if (iTittel) { poeng += iTittel * 20; continue; }
          const iAndre = treffOrd(alt, p.andreOrd);
          if (iAndre) { poeng += iAndre * 8; continue; }
          if (t.length >= 4 && alt.some(({ a }) => p.tekst.includes(a))) { poeng += 6; continue; }
          ok = false; break;
        }
        if (!ok) continue;
      }

      /* Produkttypen er kategorien: «lim» skal gi limene foer limfjerneren */
      if (p.typeNorm && (p.typeNorm === hel || alternativer(hel).some(({ a }) => a === p.typeNorm))) poeng += 45;

      const tittel = norm(p.tittel);
      if (tittel === hel) poeng += 80;
      else if (tittel.startsWith(hel)) poeng += 40;
      if (p.ledig) poeng += 15;

      /* Velg varianten som best passer ordene i soeket, f.eks. «c 0.07 10mm» */
      if (!variant && p.varianter.length > 1) {
        let bestV = 0;
        for (const v of p.varianter) {
          const vo = ord(v.tittel);
          let n = 0;
          tokens.forEach((t) => {
            if (vo.includes(t)) n += 2;
            else if (vo.some((w) => w.startsWith(t))) n += 1;
          });
          if (n && v.ledig) n += 0.5;
          if (n > bestV) { bestV = n; variant = v; }
        }
      }
      ut.push({ p, poeng, variant });
    }

    ut.sort((a, b) => b.poeng - a.poeng || a.p.tittel.localeCompare(b.p.tittel, 'nb'));
    return ut;
  }

  /* ── Kurven ───────────────────────────────────────────────────── */
  const kurvLyttere = new Set();

  async function oppdaterKurv() {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
      kurvLyttere.forEach((f) => f(cart));
    } catch (e) { /* kurven oppdateres ved neste sidevisning */ }
  }

  async function leggI(id, antall, knapp) {
    const tekst = knapp.innerHTML;
    knapp.disabled = true;
    knapp.textContent = 'Legger i …';
    try {
      const svar = await fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: antall }] })
      });
      const data = await svar.json();
      if (!svar.ok) throw new Error(data.description || data.message || 'Kunne ikke legge i kurven');
      knapp.classList.add('bs-knapp--ok');
      knapp.textContent = '✓ Lagt i kurv';
      await oppdaterKurv();
    } catch (e) {
      knapp.classList.add('bs-knapp--feil');
      knapp.textContent = 'Ikke nok på lager';
      knapp.title = e.message;
    }
    setTimeout(() => {
      knapp.disabled = false;
      knapp.classList.remove('bs-knapp--ok', 'bs-knapp--feil');
      knapp.innerHTML = tekst;
    }, 1800);
  }

  /* ── Visning av ett treff ─────────────────────────────────────── */
  function radHtml(t) {
    const p = t.p;
    const v = t.variant || p.varianter.find((x) => x.ledig) || p.varianter[0];
    const url = '/products/' + p.handle + (p.varianter.length > 1 ? '?variant=' + v.id : '');
    const bilde = p.bilde
      ? '<img src="' + esc(p.bilde) + '" alt="" loading="lazy" width="64" height="64">'
      : '<span class="bs-bilde__tom"></span>';
    const meta = [p.merke, p.type].filter(Boolean).map(esc).join(' · ');

    if (!p.tilgang) {
      const lenke = C.innlogget
        ? '<a class="bs-knapp bs-knapp--rolig" href="' + esc(C.bliPartnerUrl) + '">Søk om tilgang</a>'
        : '<a class="bs-knapp bs-knapp--rolig" href="' + esc(C.loginUrl) + '">Logg inn</a>';
      return '<div class="bs-rad bs-rad--laast">' +
        '<a class="bs-bilde" href="' + url + '" tabindex="-1">' + bilde + '</a>' +
        '<div class="bs-info"><a class="bs-tittel" href="' + url + '">' + esc(p.tittel) + '</a>' +
        '<div class="bs-meta">' + meta + '</div>' +
        '<div class="bs-merkelapp">Partnervare</div></div>' +
        '<div class="bs-kjop">' + lenke + '</div></div>';
    }

    let velger = '';
    if (p.varianter.length > 1) {
      velger = '<select class="bs-variant" aria-label="Velg variant">' +
        p.varianter.map((x) => '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') +
          (x.ledig ? '' : ' disabled') + ' data-pris="' + x.pris + '" data-sku="' + esc(x.sku) + '">' +
          esc(x.tittel) + ' · ' + kr(x.pris) + (x.ledig ? '' : ' · utsolgt') + '</option>').join('') +
        '</select>';
    }
    const sku = v.sku ? '<span class="bs-sku">Varenr. <span data-sku>' + esc(v.sku) + '</span></span>' : '';
    const forpris = v.forpris > v.pris ? '<s>' + kr(v.forpris) + '</s>' : '';
    const kjop = p.ledig
      ? '<div class="bs-antall" role="group" aria-label="Antall">' +
          '<button type="button" data-minus aria-label="Færre">−</button>' +
          '<input type="number" inputmode="numeric" min="1" value="1" aria-label="Antall">' +
          '<button type="button" data-pluss aria-label="Flere">+</button></div>' +
        '<button type="button" class="bs-knapp" data-legg-i>Legg i kurv</button>'
      : '<span class="bs-utsolgt">Utsolgt</span>';

    return '<div class="bs-rad' + (p.ledig ? '' : ' bs-rad--utsolgt') + '" data-variant="' + v.id + '">' +
      '<a class="bs-bilde" href="' + url + '" tabindex="-1">' + bilde + '</a>' +
      '<div class="bs-info"><a class="bs-tittel" href="' + url + '">' + esc(p.tittel) + '</a>' +
      '<div class="bs-meta">' + meta + (sku ? ' · ' + sku : '') + '</div>' + velger + '</div>' +
      '<div class="bs-pris"><span data-pris>' + kr(v.pris) + '</span>' + forpris +
        '<small>' + mvaTekst + '</small></div>' +
      '<div class="bs-kjop">' + kjop + '</div></div>';
  }

  /* Felles handlere for antall, variant og Legg i kurv. Kobles paa en
     beholder, saa nye treff virker uten egne lyttere. */
  function kobleKjop(boks) {
    boks.addEventListener('click', (e) => {
      const rad = e.target.closest('.bs-rad');
      if (!rad) return;
      const felt = rad.querySelector('.bs-antall input');
      if (e.target.closest('[data-minus]')) felt.value = Math.max(1, (+felt.value || 1) - 1);
      else if (e.target.closest('[data-pluss]')) felt.value = (+felt.value || 1) + 1;
      else if (e.target.closest('[data-legg-i]')) {
        leggI(rad.dataset.variant, Math.max(1, +felt.value || 1), e.target.closest('[data-legg-i]'));
      }
    });
    boks.addEventListener('change', (e) => {
      if (!e.target.classList.contains('bs-variant')) return;
      const rad = e.target.closest('.bs-rad');
      const valgt = e.target.selectedOptions[0];
      rad.dataset.variant = valgt.value;
      const pris = rad.querySelector('[data-pris]');
      if (pris) pris.textContent = kr(+valgt.dataset.pris);
      const sku = rad.querySelector('[data-sku]');
      if (sku) sku.textContent = valgt.dataset.sku;
      rad.querySelectorAll('a[href*="/products/"]').forEach((a) => {
        a.href = a.href.split('?')[0] + '?variant=' + valgt.value;
      });
    });
    boks.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.matches('.bs-antall input')) {
        e.preventDefault();
        e.target.closest('.bs-rad').querySelector('[data-legg-i]').click();
      }
    });
  }

  function listeHtml(treff, grense) {
    const aapne = treff.filter((t) => t.p.tilgang);
    const laaste = treff.filter((t) => !t.p.tilgang);
    let html = aapne.slice(0, grense).map(radHtml).join('');
    if (laaste.length && aapne.length < grense) {
      html += '<div class="bs-gruppe">' + (C.innlogget
        ? 'Partnervarer du ikke har tilgang til ennå'
        : 'Partnervarer · logg inn for å se pris') + '</div>';
      html += laaste.slice(0, Math.max(3, grense - aapne.length)).map(radHtml).join('');
    }
    return html;
  }

  const POPULAERE = ['Lim', 'Limfjerner', 'Pads', 'Teip', 'Hansker', 'Benkepapir', 'Mikrobørster', 'Lash Filler', 'Filmvoks', 'Spatler'];

  function tomtHtml() {
    let html = '<div class="bs-tomt"><p class="bs-tomt__hint">Søk på produktnavn, merke, varenummer eller strekkode. ' +
      'Skriv antall og trykk Enter for å legge rett i kurven.</p><div class="bs-forslag">' +
      POPULAERE.map((o) => '<button type="button" data-forslag="' + esc(o) + '">' + esc(o) + '</button>').join('') +
      '</div>';
    html += '<a class="bs-snarvei" href="' + esc(C.bestillUrl || '/pages/partner?view=varebestilling') + '">Gå til varebestilling →</a>';
    return html + '</div>';
  }

  /* ── Soekevinduet ─────────────────────────────────────────────── */
  let vindu, felt, treffEl, fotEl, kurvEl, forrigeFokus;

  function byggVindu() {
    vindu = document.createElement('div');
    vindu.className = 'bs';
    vindu.hidden = true;
    vindu.setAttribute('role', 'dialog');
    vindu.setAttribute('aria-modal', 'true');
    vindu.setAttribute('aria-label', 'Søk i butikken');
    vindu.innerHTML =
      '<div class="bs-bakgrunn" data-lukk></div>' +
      '<div class="bs-panel">' +
        '<div class="bs-topp">' +
          '<svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M16.5 16.5L21 21" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
          '<input type="search" class="bs-felt" placeholder="Hva trenger salongen?" aria-label="Søk" autocomplete="off" autocorrect="off" spellcheck="false" enterkeyhint="search">' +
          '<button type="button" class="bs-lukk" data-lukk>Lukk</button>' +
        '</div>' +
        '<div class="bs-treff" aria-live="polite"></div>' +
        '<div class="bs-fot" hidden><a class="bs-alle" href="#">Se alle treff</a><a class="bs-kurv" href="' + esc(C.kurvUrl) + '"></a></div>' +
      '</div>';
    document.body.appendChild(vindu);
    felt = vindu.querySelector('.bs-felt');
    treffEl = vindu.querySelector('.bs-treff');
    fotEl = vindu.querySelector('.bs-fot');
    kurvEl = vindu.querySelector('.bs-kurv');

    vindu.addEventListener('click', (e) => {
      if (e.target.closest('[data-lukk]')) lukk();
      const f = e.target.closest('[data-forslag]');
      if (f) { felt.value = f.dataset.forslag; tegn(); felt.focus(); }
    });
    vindu.addEventListener('keydown', (e) => { if (e.key === 'Escape') lukk(); });
    felt.addEventListener('input', () => { clearTimeout(felt._t); felt._t = setTimeout(tegn, 90); });
    felt.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        /* Ett treff paa varenummer: rett i kurven. Ellers til soekesiden. */
        const forste = treffEl.querySelector('.bs-rad:not(.bs-rad--laast) [data-legg-i]');
        if (forste && treffEl.querySelectorAll('.bs-rad').length === 1) forste.click();
        else if (felt.value.trim()) location.href = C.sokUrl + '?q=' + encodeURIComponent(felt.value.trim());
      }
      if (e.key === 'ArrowDown') {
        const f = treffEl.querySelector('.bs-antall input, .bs-tittel');
        if (f) { e.preventDefault(); f.focus(); if (f.select) f.select(); }
      }
    });
    kobleKjop(treffEl);
    kurvLyttere.add(visKurv);
  }

  function visKurv(cart) {
    if (!kurvEl) return;
    kurvEl.textContent = cart.item_count
      ? 'Kurven: ' + cart.item_count + (cart.item_count === 1 ? ' vare' : ' varer') + ' · ' + kr(cart.total_price) + ' →'
      : '';
    kurvEl.hidden = !cart.item_count;
  }

  async function tegn() {
    const q = felt.value.trim();
    if (!q) { treffEl.innerHTML = tomtHtml(); fotEl.hidden = true; return; }
    if (!indeks) {
      treffEl.innerHTML = '<p class="bs-melding">Henter sortimentet …</p>';
      try { await hentIndeks(); } catch (e) {
        treffEl.innerHTML = '<p class="bs-melding">Søket fikk ikke kontakt. Trykk Enter for å søke på vanlig måte.</p>';
        return;
      }
      if (felt.value.trim() !== q) return;
    }
    const treff = sok(q);
    if (!treff.length) {
      treffEl.innerHTML = '<p class="bs-melding">Ingen treff på «' + esc(q) + '». Prøv et kortere ord eller varenummeret.</p>' + tomtHtml();
      fotEl.hidden = true;
      return;
    }
    treffEl.innerHTML = listeHtml(treff, MAKS_VINDU);
    const alle = vindu.querySelector('.bs-alle');
    alle.href = C.sokUrl + '?q=' + encodeURIComponent(q);
    alle.textContent = treff.length > MAKS_VINDU ? 'Se alle ' + treff.length + ' treff' : 'Åpne på egen side';
    fotEl.hidden = false;
  }

  function aapne(start) {
    if (!vindu) byggVindu();
    forrigeFokus = document.activeElement;
    vindu.hidden = false;
    document.documentElement.classList.add('bs-aapen');
    if (typeof start === 'string') felt.value = start;
    tegn();
    oppdaterKurv();
    requestAnimationFrame(() => { felt.focus(); felt.select(); });
  }

  function lukk() {
    vindu.hidden = true;
    document.documentElement.classList.remove('bs-aapen');
    if (forrigeFokus && forrigeFokus.focus) forrigeFokus.focus();
  }

  /* Ta over temaets soekeknapper. Fanges foer temaet faar klikket. */
  document.addEventListener('click', (e) => {
    const k = e.target.closest('[data-popdown-toggle="search-popdown"], a[href="/search"], [data-byuti-sok-aapne]');
    if (!k || k.closest('.bs')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    aapne();
  }, true);

  document.addEventListener('focusin', (e) => {
    if (e.target.matches('[data-drawer-search] input[type="search"], .search__predictive input[type="search"]') &&
        !document.querySelector('[data-byuti-sokeside]')) {
      const v = e.target.value;
      e.target.blur();
      aapne(v);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== '/' || e.metaKey || e.ctrlKey) return;
    const t = e.target;
    if (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
    e.preventDefault();
    aapne();
  });

  /* Last indeksen naar nettleseren er ledig, saa foerste soek er raskt */
  const forhaand = () => hentIndeks().catch(() => {});
  if ('requestIdleCallback' in window) requestIdleCallback(forhaand, { timeout: 4000 });
  else setTimeout(forhaand, 2500);

  /* ── Soekesiden ───────────────────────────────────────────────── */
  function monterSokeside(rot) {
    const sidefelt = rot.querySelector('.bs-side__felt');
    const filtre = rot.querySelector('[data-filtre]');
    const liste = rot.querySelector('[data-liste]');
    const antallEl = rot.querySelector('[data-antall]');
    let merke = null, type = null, treff = [];
    kobleKjop(liste);

    function brikker(navn, felt, aktiv) {
      const teller = {};
      treff.forEach((t) => {
        if (!t.p.tilgang) return;
        if (felt === 'type' && merke && t.p.merke !== merke) return;
        const k = t.p[felt] || 'Annet';
        teller[k] = (teller[k] || 0) + 1;
      });
      const rader = Object.entries(teller).sort((a, b) => b[1] - a[1]);
      if (rader.length < 2) return '';
      return '<div class="bs-filter"><span class="bs-filter__navn">' + navn + '</span>' +
        '<button type="button" data-' + felt + '=""' + (aktiv ? '' : ' class="on"') + '>Alle</button>' +
        rader.map(([k, n]) => '<button type="button" data-' + felt + '="' + esc(k) + '"' +
          (k === aktiv ? ' class="on"' : '') + '>' + esc(k) + ' <span>' + n + '</span></button>').join('') +
        '</div>';
    }

    function vis() {
      let utvalg = treff;
      if (merke) utvalg = utvalg.filter((t) => t.p.merke === merke);
      if (type) utvalg = utvalg.filter((t) => (t.p.type || 'Annet') === type);
      filtre.innerHTML = brikker('Merke', 'merke', merke) + brikker('Type', 'type', type);
      const synlige = utvalg.filter((t) => t.p.tilgang).length;
      antallEl.textContent = synlige
        ? synlige + (synlige === 1 ? ' treff' : ' treff')
        : '';
      liste.innerHTML = utvalg.length
        ? listeHtml(utvalg, 200)
        : '<p class="bs-melding">Ingen treff på «' + esc(sidefelt.value) + '». Prøv et kortere ord eller varenummeret.</p>';
    }

    async function kjor() {
      const q = sidefelt.value.trim();
      merke = null; type = null;
      const url = new URL(location.href);
      url.searchParams.set('q', q);
      history.replaceState(null, '', url);
      if (!q) { treff = []; filtre.innerHTML = ''; antallEl.textContent = ''; liste.innerHTML = tomtHtml(); return; }
      liste.innerHTML = '<p class="bs-melding">Henter sortimentet …</p>';
      try { await hentIndeks(); } catch (e) {
        liste.innerHTML = '<p class="bs-melding">Søket fikk ikke kontakt. Last siden på nytt.</p>';
        return;
      }
      treff = sok(q);
      vis();
    }

    filtre.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b) return;
      if ('merke' in b.dataset) { merke = b.dataset.merke || null; type = null; }
      if ('type' in b.dataset) type = b.dataset.type || null;
      vis();
    });
    liste.addEventListener('click', (e) => {
      const f = e.target.closest('[data-forslag]');
      if (f) { sidefelt.value = f.dataset.forslag; kjor(); }
    });
    rot.querySelector('form').addEventListener('submit', (e) => { e.preventDefault(); kjor(); });
    sidefelt.addEventListener('input', () => { clearTimeout(sidefelt._t); sidefelt._t = setTimeout(kjor, 200); });
    kjor();
  }

  const start = () => document.querySelectorAll('[data-byuti-sokeside]').forEach(monterSokeside);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.byutiSok = { aapne, sok, hentIndeks, listeHtml, kobleKjop };
})();
